<template>
	<div :data-cy="containerCyId">
		<template v-if="component">
			<div
				:style="`height:${removedPagesPlaceholderHeight()}px;`"
				id="removedpagesplaceholder"
				v-if="removedPages"
			></div>
			<template v-if="loading">
				<component
					:is="component"
					v-for="index in 5"
					:key="`skeletonloading-${index}`"
					:class="itemClass"
				/>
			</template>
			<template v-if="pagesLoadingBefore">
				<component
					:is="component"
					v-for="index in responses[0][dataProperty].length * pagesLoadingBefore"
					:key="`skeletonloadingbefore-${index}`"
					:class="itemClass"
				/>
			</template>
			<template v-if="!loading && cols">
				<div class="list-group-item d-none d-sm-block">
					<div class="row">
						<div
							v-for="col in cols"
							v-bind:key="col.key"
							:class="`col-xs-12 col-sm-${col.size} font-bold`"
						>
							{{ col.heading }}
						</div>
					</div>
				</div>
			</template>
			<component
				:is="component"
				v-for="(item, index) in data"
				:data="item"
				:key="item.id"
				class="data-item"
				:class="itemClass"
				@selectItem="selectItem"
				@swipeLeftItem="swipeLeftItem"
				@swipeRightItem="swipeRightItem"
				@contextMenuItem="contextMenuItem"
				@deleteItem="deleteItem"
				:selectedItem="selectedItem"
				:swipedLeftItem="swipedLeftItem"
				:idProperty="idProperty"
				:deletePriv="deletePriv"
				@removeItem="removeItem"
				:cols="cols"
				:breakpoint="breakpoint"
				:data-cy="`selector-item-${index}`"
				:bulkMode="bulkMode"
				:selectedItems="selectedItems"
				@toggleSelectItem="$emit('toggleSelectItem', $event)"
			/>
			<div v-if="!loading && !data.length" class="pt-4">
				<div class="alert alert-info alert-no-results">
					{{ noResultsText ? noResultsText : $t("no-results-found") }}
				</div>
			</div>
			<template v-if="pagesLoadingAfter">
				<component
					:is="component"
					v-for="index in responses[0][dataProperty].length * pagesLoadingAfter"
					:key="`skeletonloadingafter-${index}`"
					:class="itemClass"
				/>
			</template>
		</template>
	</div>
</template>

<script>
export default {
	name: "InfiniteScroll",
	props: {
		scrollElementId: String,
		type: String,
		dataUrl: String,
		dataProperty: String,
		lookaheadPx: Number,
		itemClass: String,
		idProperty: {
			type: String,
			default: "id",
		},
		deletePriv: String,
		autoSelectId: String,
		noResultsText: String,
		containerCyId: String,
		method: String,
		tableView: Boolean,
		cols: Array,
		breakpoint: String,
		bulkMode: {
			type: Boolean,
			default: false,
		},
		selectedItems: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			data: [],
			moreData: true,
			responses: [],
			removedPages: 0, // number of pages removed by memory management - used to calculate height of placeholder to maintain scroll behaviour
			pagesLoadingBefore: 0,
			pagesLoadingAfter: 0,
			loading: true, // initial load
			component: null,
			scrollElement: null,
			lastScrollTop: 0,
			firstPage: 1,
			lastPage: 1,
			selectedItem: null,
			swipedLeftItem: null,
			bodySansPage: {},
			doneAutoSelect: false,

		};
	},
	mounted() {
		//console.log("mounted");
		this.scrollElement = this.scrollElementId
			? window.document.getElementById(this.scrollElementId)
			: this.$el;
		this.scrollElement.addEventListener("scroll", this.handleScroll);

		this.loader().then(() => {
			//console.log("loader");
			this.component = () => this.loader();
		});
		/*.catch(() => {
				//this.component = () => import('templates/default')
			})*/

		//this.getData();
	},
	created: function () {},
	destroyed: function () {
		this.scrollElement.removeEventListener("scroll", this.handleScroll);
	},
	methods: {
		swipeLeftItem(item) {
			this.swipedLeftItem = item;
		},
		swipeRightItem(item) {
			if (
				this.swipedLeftItem &&
				item[this.idProperty] == this.swipedLeftItem[this.idProperty]
			) {
				this.swipedLeftItem = null;
			}
		},
		contextMenuItem(item) {
			if (
				this.swipedLeftItem &&
				item[this.idProperty] == this.swipedLeftItem[this.idProperty]
			) {
				this.swipedLeftItem = null;
			} else {
				this.swipedLeftItem = item;
			}
		},
		getItemById(id) {
			for (let item of this.data) {
				if (item[this.idProperty] == id) {
					return item;
				}
			}
		},
		getItemIndex(item) {
			for (let i = 0; i < this.data.length; i++) {
				if (this.data[i][this.idProperty] == item[this.idProperty]) {
					return i;
				}
			}
		},
		removeItem(item) {
			const itemIndex = this.getItemIndex(item);
			const pageLength = this.responses[0][this.dataProperty].length;
			// zero based page
			const page = Math.floor(itemIndex / pageLength);
			// remove this page and any higher pages
			this.responses.splice(page);
			this.data.splice(page * pageLength);
			// fetch this page again
			if (page) {
				this.lastPage = page;
				this.getData("append");
			} else {
				this.getData("replace");
			}
		},
		selectItem(item) {
			this.selectedItem = item;
			this.$emit("selectItem", item);
		},
		deleteItem(item) {
			this.$emit("deleteItem", item);
		},
		handleScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
			//console.log("handleScroll");
			const lookaheadPx = this.lookaheadPx ? this.lookaheadPx : 200; /* default */

			if (
				scrollTop > this.lastScrollTop &&
				scrollTop + clientHeight >= scrollHeight - lookaheadPx
			) {
				if (this.moreData) {
					this.getData("append");
				}
			}

			const $removedPagesPlaceholder = this.$el.querySelector("#removedpagesplaceholder");
			if (scrollTop < this.lastScrollTop && $removedPagesPlaceholder) {
				const b1 = $removedPagesPlaceholder.getBoundingClientRect();
				const b2 = this.scrollElement.getBoundingClientRect();
				if (b1.bottom > b2.top && b1.top < b2.bottom) {
					// placeholder in view
					this.getData("prepend");
				}
			}

			this.lastScrollTop = scrollTop;
		},

		getData(mode = "replace", body = this.bodySansPage) {
			//console.log("getData");
			if (mode == "append") {
				this.pagesLoadingAfter++;

				// fetch one higher than the highest page
				this.lastPage++;
				body.pg = this.lastPage;
			} else if (mode == "prepend") {
				this.pagesLoadingBefore++;
				this.removedPages--;
				this.firstPage--;

				// fetch one lower than lowest page
				body.pg = this.firstPage;
			} else {
				this.loading = true;
				// overwrite
				this.bodySansPage = body;

				this.firstPage = 1;
				this.lastPage = 1;
				body.pg = this.firstPage;
				this.moreData = true;
			}
			this.$cfetch(this.dataUrl, {
				method: this.method || "post",
				data: body,
			})
				.then((json) => {
					if (json.status.toLowerCase() === "success") {
						//console.log("index json", json);
						if (mode == "replace") {
							// if replace don't push - replace with [json]
							this.responses = [json];
						} else {
							this.responses.push(json);
							// sort responses by page to ensure correct ordering
							this.responses.sort((a, b) => a.pagination.page - b.pagination.page);
						}

						if (mode == "append") {
							// check max size and remove oldest if need be
							const maxPages = 10;
							if (this.responses.length > maxPages) {
								this.responses.splice(0, 1); // remove first page of responses
								this.removedPages++;
								this.firstPage++;
							}
							this.pagesLoadingAfter--;
						} else if (mode == "prepend") {
							this.responses.pop();
							this.lastPage--;
							this.pagesLoadingBefore--;
						}
						this.loading = false;

						// Merge arrays from object property in an object array
						let data = [];
						for (let i = 0; i < this.responses.length; i++) {
							data = data.concat(this.responses[i][this.dataProperty]);
						}
						this.data = data;

						if (Object.hasOwnProperty.call(json.pagination, "total")) {
							this.moreData = json.pagination.to < json.pagination.total;
						} else if (Object.hasOwnProperty.call(json.pagination, "limit")) {
							this.moreData = json[this.dataProperty].length == json.pagination.limit;
						}

						this.$nextTick(function () {
							// $nextTick seems to be firing too quicky - could use a short timeout instead?

							if (
								this.moreData &&
								this.scrollElement.scrollHeight <= this.scrollElement.clientHeight
							) {
								this.getData("append");
							}
						});

						if (this.autoSelectId && !this.doneAutoSelect) {
							const item = this.getItemById(this.autoSelectId);
							if (item) {
								this.selectItem(item);
							}
							this.doneAutoSelect = true;
						}
					} else {
						this.$log.error.call(this, "Could not fetch data");
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
		},
		removedPagesPlaceholderHeight() {
			if (this.responses.length && this.$el.querySelector(".data-item")) {
				return (
					this.removedPages *
					this.responses[0][this.dataProperty].length *
					this.$el.querySelector(".data-item").offsetHeight
				);
			} else {
				return 0;
			}
		},
	},
	computed: {
		loader() {
			if (!this.type) {
				return null;
			}
			return () => import(`./templates/${this.type}`);
		},
	},
};
</script>
